import { saveAs } from "file-saver";
import { InfoMessage } from 'components';
import docSupDespDeclar from 'assets/documents/Υπεύθυνη Δήλωση Νόμιμου Εκπροσώπου_ΔΙΚ1.docx';

export const content = () =>
  [
    {
      label: 
      <div style={{display:'flex', marginRight:'5px'}}>
                <b>Υποβολή Υπεύθυνης Δήλωσης</b><text style={{fontWeight:"normal", fontSize:"11px"}}>(Κατεβάστε το υπόδειγμα <a style={{textDecoration: "underline"}} onClick={()=>saveAs(docSupDespDeclar, "Υπόδειγμα Υπεύθυνης Δήλωσης")}>εδώ</a>)</text>
      </div>,     
      fileCode: 'supDespDeclar',
      id: 'supDespDeclar',
      fileLimit: 10,
      multiple: true,
      required: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
    },
    {
      label: <div style={{display:'flex', marginRight:'5px'}}>Πιστοποιητικό Εκπροσώπησης και αντίγραφο της αντίστοιχης καταχώρησης στο ΓΕΜΗ 
                <InfoMessage
                infoMessage="Προσκόμιση Πιστοποιητικού Εκπροσώπησης και αντιγράφου της αντίστοιχης καταχώρησης στο ΓΕΜΗ από το οποίο να προκύπτει (να είναι εμφανές) το όνομα του υπογράφοντος της προηγούμενης Υπεύθυνης Δήλωσης (ΔΙΚ1) καθώς και κάθε άλλης δήλωσης-βεβαίωσης στην αίτηση Συμμετοχής. Αναλόγως της νομικής μορφής της επιχείρησης, εφόσον τα παραπάνω έγγραφα δεν είναι επαρκή ή δεν εκδίδονται (πχ ατομική επιχείρηση), προσκομίζεται Γενικό Πιστοποιητικό ή άλλο έγγραφο που συνδυαστικά με το προηγούμενο ή αυτοτελώς τεκμηριώνει τη νόμιμη εκπροσώπηση του υπογράφοντος τη δήλωση. Για εταιρίες εξωτερικού χωρίς παρουσία στην Ελλάδα παρακαλώ ελέγξτε τις πληροφορίες στο τέλος της σελίδας."
                overlayClassName={'multiline-info-message'}
                />
              </div>,
      fileCode: 'supCertGemi',
      id: 'supCertGemi',
      fileLimit: 10,
      multiple: true,
      required: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
    },
    {
      label: <div style={{display:'flex', marginRight:'5px'}}>Προσωποποιημένη Πληροφόρηση της Επιχείρησης από το μητρώο του TAXISNET 
                <InfoMessage
                infoMessage="Μη επικυρωμένο αντίγραφο - εκτύπωση της προσωποποιημένης πληροφόρησης της επιχείρησης από το μητρώο του TAXISNET. Σε περίπτωση υποκαταστήματος, απαιτείται επιπροσθέτως και η εκτύπωση των αναλυτικών στοιχείων του υποκαταστήματος από την προσωποποιημένη πληροφόρηση της επιχείρησης από το TAXISΝΕΤ. Για εταιρίες εξωτερικού χωρίς παρουσία στην Ελλάδα παρακαλώ ελέγξτε τις πληροφορίες στο τέλος της σελίδας."
                overlayClassName={'multiline-info-message'}
                />
              </div>,
      fileCode: 'supRegistryTaxisnet',
      id: 'supRegistryTaxisnet',
      fileLimit: 10,
      multiple: true,
      required: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
    },
    {
      label: <div style={{display:'flex', marginRight:'5px'}}>Εκτύπωση στοιχείων IBAN
                <InfoMessage
                infoMessage="Εκτύπωση στοιχείων λογαριασμού από τράπεζα με εμφανή τον αριθμό λογαριασμού IBAN και τα στοιχεία του δικαιούχου του λογαριασμού, τα οποία πρέπει να ταυτίζονται με τα στοιχεία του προμηθευτή."
                overlayClassName={'multiline-info-message'}
                />
              </div>,
      fileCode: 'supIbanDetails',
      id: 'supIbanDetails',
      fileLimit: 10,
      multiple: true,
      required: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
    },
    {
      label: <div style={{display:'flex', marginRight:'5px'}}>Λοιπά Έγγραφα
                {/* <InfoMessage
                infoMessage={'Εκτύπωση στοιχείων IBAN.'}
                overlayClassName={'multiline-info-message'}
                /> */}
              </div>,
      fileCode: 'supOtherDocs',
      id: 'supOtherDocs',
      fileLimit: 10,
      multiple: true,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
      descriptionUpload: 'Κάντε κλικ για ανέβασμα ή σύρετε και αποθέστε αρχεία'
    },
  ].filter(item => item);;
